// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c8227976","239":"5b68e502","455":"887ed092","488":"f8e8bee8"}[chunkId] + ".chunk.js";
};